// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBS7XOMIvpAz9QOikTlC29-zXkZEKsD9qE",
  authDomain: "duely-8797c.firebaseapp.com",
  projectId: "duely-8797c",
  storageBucket: "duely-8797c.appspot.com",
  messagingSenderId: "760356008939",
  appId: "1:760356008939:web:be724799beeffe0bf45fae",
  measurementId: "G-Y0BKR653P8"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);